import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import SVG from 'react-inlinesvg';
import cn from 'classnames';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import Tooltip from '../../shared/Tooltip';
import ConfigContext from '../../../contexts/ConfigContext';

// Styles
import styles from './MapPin.module.postcss';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);
dayjs.tz.setDefault('America/Los_Angeles');

function MapHover({ location }) {
  const { imageBase } = useContext(ConfigContext);
  const { address, location_slug, display_name: title } = location[0];

  return (
    <div className={styles.MapHover}>
      <Link to={`/schedule/${location_slug}`} className={styles.MapHover_Title}>{title}</Link>
      <div className={styles.MapHover_Address}>
        <div><img src='/static/images/icons/pin.svg' alt='Address'/></div>
        <div>{address}</div>
      </div>

      { location.map((event) => {
        return (
          <React.Fragment key={'mapEvent-' + event.id}>
            <div className={styles.MapHover_Time}>
              <div><img src='/static/images/icons/clock.svg' alt='Event Time'/></div>
              <div>{dayjs(event.start_time).tz().format('h:mma')} - {dayjs(event.end_time).tz().format('h:mma')}</div>
            </div>
            <div>
              { event.bookings.map(({ truck }) => {
                const { id, featured_photo, name, food_categories_string } = truck;

                let image = '/static/images/truck-placeholder.png';
                if (featured_photo) {
                  image = `${imageBase}/${featured_photo}`;
                }

                return (
                  <Link to={`/food-trucks/${id}`} className={styles.MapHover_Truck} key={'mapTruck-' + event.id + '-' + id}>
                    <div
                      className={styles.MapHover_TruckImage}
                      style={{
                        backgroundImage: `url("${image}")`
                      }}
                    />

                    <div className={styles.MapHover_TruckInfo}>
                      <div className={styles.MapHover_TruckName}>{name}</div>
                      <div className={styles.MapHover_TruckCategories}>{food_categories_string || '\u00A0'}</div>
                    </div>
                  </Link>
                );
              }) }
            </div>
          </React.Fragment>
        );
      }) }
    </div>
  );
}

function MapPin({ location, hover = false }) {
  return (
    <div className={styles.MapPin}>
      <Tooltip
        lightTheme
        placement='left'
        triggerOnClick
        content={<MapHover location={location} />}
      >
        <div className={styles.MapPin__inner}>
          <SVG
            src='/static/images/map-pin.svg'
            className={cn(styles.MapPin_Icon, {
              [styles.MapPin_Icon__hover]: hover,
            })}
          />
        </div>
      </Tooltip>
    </div>
  );
}

MapPin.propTypes = {
  location: PropTypes.array.isRequired,
  hover: PropTypes.bool,
};

export default MapPin;
